'use strict';

var $ = require('jquery'),
  Backbone = require('backbone'),
  config = require('../config'),

  TabbedContentView = Backbone.View.extend({

    events: {
      'click .TabbedContent-tab': 'onTabClick',
      'keydown .TabbedContent-tab': 'onKeydown'
    },
    tabbedContentBody: function() {
      let $products1 = this.$el.find('.TabbedContent-content');
      if (this.windowSize.matches)
      {
        $products1[1].setAttribute('aria-hidden', false);
        $products1[0].setAttribute('aria-hidden', false);
      }
      this.changeAttributes();
    },

    initialize: function() {
      let $tab = this.$el.find('.TabbedContent-tab');
      let $content = this.$el.find('.TabbedContent-content');
      if (this.$el.hasClass(config.classes.productLandingTabbedContentTabs)) {
        $tab.eq(1).addClass(config.classes.isActive);
        $tab.eq(1).attr('aria-selected',true);
        $tab.eq(1).attr('tabindex','0');
        $content.eq(1).addClass(config.classes.isActive);
        $tab.eq(0).removeClass(config.classes.isActive);
        $content.eq(0).removeClass(config.classes.isActive);
        $tab.eq(0).attr('aria-selected',false);
        $tab.eq(0).attr('tabindex','-1');
      } else {
        $tab.eq(0).addClass(config.classes.isActive);
        $content.eq(0).addClass(config.classes.isActive);
        $tab.eq(0).attr('aria-selected',true);
        $tab.eq(0).attr('tabindex','0');
        $tab.eq(1).removeClass(config.classes.isActive);
        $content.eq(1).removeClass(config.classes.isActive);
        $tab.eq(1).attr('aria-selected',false);
        $tab.eq(1).attr('tabindex','-1');
      }
      this.windowSize = window.matchMedia('(max-width: 600px)')
      let baseView = this;
      $(window).on('resize', function() { baseView.tabbedContentBody(); });
      this.tabbedContentBody();
    },

    onTabClick: function(e) {
      e.preventDefault();

      var $target = $(e.currentTarget),
        href = $target.attr('href');

      if ($target.hasClass(config.classes.isActive) || !href) return;

      // Switch classes on tabs and content panels
      this.toggleTabsClass($target);
      this.switchTab(href);
      this.changeAttributes();
    },

    toggleTabsClass: function($element) {
      $element.siblings().removeClass(config.classes.isActive);
      $element.addClass(config.classes.isActive);
      $element.siblings().attr('aria-selected',false);
      $element.attr('aria-selected',true);
      $element.siblings().attr('tabindex','-1');
      $element.attr('tabindex','0');
    },

    switchTab: function(href) {
      var $tabContent = $(href);
      $tabContent.siblings().removeClass(config.classes.isActive);
      $tabContent.addClass(config.classes.isActive);
    },

    changeAttributes: function() {
      let $products = this.$el.find('.TabbedContent-content');
      if (this.$el.find('#tab-1').hasClass(config.classes.isActive)) {
        $products[1].setAttribute('aria-hidden', true);
        $products.eq(1).addClass('is-disabled');
        $products.eq(1).removeClass('is-visible');
        $products[0].setAttribute('aria-hidden', false);
        $products.eq(0).addClass('is-visible');
        $products.eq(0).removeClass('is-disabled');
      }
      else {
        $products[1].setAttribute('aria-hidden', false);
        $products.eq(1).addClass('is-visible');
        $products.eq(1).removeClass('is-disabled');
        $products[0].setAttribute('aria-hidden', true);
        $products.eq(0).addClass('is-disabled');
        $products.eq(0).removeClass('is-visible');
      }
    },

    onKeydown: function(event) {
      var $newTarget = null;
      var $target = $(event.currentTarget);
      switch (event.key) {
        case 'ArrowLeft':
          var $prev = $target.prev();
          if ($prev && $prev.length)
          {
            $newTarget = $prev;
          }
          else {
            var $siblings = $target.siblings();
            $newTarget = $($siblings[$siblings.length - 1]);
          }
          break;
        case 'ArrowRight':
          var $next = $target.next();
          if ($next && $next.length)
          {
            $newTarget = $next;
          }
          else {
            var $siblings = $target.siblings();
            $newTarget = $($siblings[0]);
          }
          break;
        default:
          break;
      }
      if ($newTarget) {
        $newTarget.focus();
        this.toggleTabsClass($newTarget);
        this.switchTab($newTarget.attr('href'));
        this.changeAttributes();
        event.stopPropagation();
        event.preventDefault();
      }
    }
  });

module.exports = TabbedContentView;



// WEBPACK FOOTER //
// ./assets/js/components/TabbedContentView.js